<template>
  <div class="process-status-form">
    <show-handle-result-dialog @updateVisible="updateVisible" :dialogVisible="showDialog" :isShowReason="isShowReason" :table-data="gridData" status="制备">
    </show-handle-result-dialog>
    <pt-form-item label="是否合格" labelWidth="100px" :required="true">
      <el-radio-group v-model="statusForm.result" name="result" v-validate="'required'" data-vv-as="是否合格">
        <el-radio label="QUALIFIED">合格</el-radio>
        <el-radio label="NOT_QUALIFIED_WAIT_FUTURE_ACTION">不合格</el-radio>
      </el-radio-group>
    </pt-form-item>
    <template v-if="statusForm.result == 'NOT_QUALIFIED_WAIT_FUTURE_ACTION'">
      <pt-form-item label="备注" labelWidth="100px">
          <el-input  type="textarea" :autosize="{ minRows: 5, maxRows: 6 }" v-model="statusForm.comment" class="texta" @mousedown.stop.native @click.stop.native></el-input>
      </pt-form-item>
    </template>

  </div>
</template>

<script>
import showHandleResultDialog from 'cps/lab-order/show-handle-result-dialog'
import { validate } from 'utils/validate'
import { handleData } from 'cps/lab-order/show-handle-result-dialog/handle-options'
// 组件class前缀
const prefixCls = 'pt-lab-samples-received-form'

export default {
  name: 'pt-lab-samples-received-form',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    isShowReason () {
      return this.statusForm.result !== 'QUALIFIED'
    }
  },
  components: {
    showHandleResultDialog
  },
  props: {
    value: {
      type: Object
    },
    isUpload: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      statusForm: JSON.stringify(this.value) !== '{}' ? this.value : {
        result: 'QUALIFIED',
        comment: ''
      },
      qualityFile: [],
      showDialog: false,
      gridData: []
    }
  },
  watch: {
    statusForm: {
      handler: function (val, oldVal) {
        this.$emit('input', val)
      },
      deep: true
    },
    qualityFile: {
      handler: function (val, old) {
        if (val.length > 1) {
          this.qualityFile = val.slice(-1)
        }
      }
    }
  },
  methods: {
    updateVisible (val) {
      this.showDialog = val
      if (!val) {
        // 更新表格数据
        this.$emit('updateTable', true)
        // 更新待处理订单数量，如若接口会返回该数据的话则不用
        this.$emit('updateAllSize', true)
      }
    },
    formValidate () {
      return validate(this, this.statusForm)
    },
    changHandler (file, fileList) {
      if (fileList.length > 1) {
        fileList.shift()
      }
      this.statusForm.qualityFile = fileList
      console.log('this.statusForm', this.statusForm)
    },
    qualityFileSub (file) {
      this.uploadForm = new FormData()
      if (file) {
        this.statusForm.qualityFile = []
        this.uploadForm.append('file', file)
        this.qualityFile.push(file)
        this.statusForm.qualityFile.push(file)
      } else {
        this.uploadForm.append('file', this.qualityFile[0])
        this.qualityFile.push(this.qualityFile[0])
        this.statusForm.qualityFile.push(this.qualityFile[0])
      }
      return false
    },
    async submit (orderIds) {
      // 传入表单和文件
      let data = {}
      data = { orderIds: orderIds, action: 'PREPARED' }
      data.orderStatusDetail = {
        orderStatusResult: this.statusForm.result
      }
      if (this.statusForm.result !== 'QUALIFIED') {
        data.orderStatusDetail.comment = this.statusForm.comment
      }
      return this.$store.dispatch('AdultOrderStatusUpdate', data)
    },
    resetForm () {
      this.statusForm = {
        result: 'QUALIFIED',
        reason: '',
        qualityFile: [],
        operatorName: {
          DNAExtractionOperator: ''
        }
      }
    },
    submitForm (memberIds = []) {
      this.submit(memberIds).then(response => {
        this.$emit('getResult', response)
        this.resetForm()
        this.showDialog = true
        this.showDialog = true
        this.gridData = handleData(response.data)
        // let info = new Set()
        // response.data.forEach(ele => {
        //   this.$emit('updateLoading', false)
        //   if (ele.status !== 'SUCCESS') {
        //     if (ele.message) {
        //       info.add(ele.message)
        //     }
        //     if (ele.status === 'NEED_APPROVAL') {
        //       info.add('进入待处理')
        //     }
        //     if (ele.status === 'FAIL') {
        //       info.add('订单操作失败')
        //     }
        //     if (ele.status === 'NOT_EXECUTED') {
        //       info.add('操作未执行')
        //     }
        //     if (ele.status === 'VALIDATION_FAILED') {
        //       info.add('订单校验失败')
        //     }
        //   }
        // })
        // if (Array.from(info).length) {
        //   this.$emit('updateLoading', false)
        //   this.$message.warning(Array.from(info).toString())
        // } else {
        //   // 更新表格数据
        //   this.$emit('updateTable', true)
        //   // 更新待处理订单数量，如若接口会返回该数据的话则不用
        //   this.$emit('updateAllSize', true)
        //   this.$message.success('操作成功！')
        // }
      }).catch(err => {
        this.$emit('getResult')
        this.$emit('updateLoading', false)
        this.$message.error(err || '操作失败！')
      })
    }
  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.process-status-form{
  margin:20px 0;
  el-textarea,.el-textarea__inner,.el-input__inner{
    width:500px;
  }
}
</style>
